import { TipoSuministroInmuebleEnum, type AddLecturaInmuebleModel, type AdjuntoLecturaInmuebleModel } from '@api/api';

export class AddLecturaInmueble implements AddLecturaInmuebleModel {

  Fecha: Date = new Date();
  Lectura: number = 0;
  Lectura2: number | null = null;
  Lectura3: number | null = null;
  TipoSuministro: TipoSuministroInmuebleEnum = TipoSuministroInmuebleEnum.Luz;
  Adjuntos: AdjuntoLecturaInmuebleModel[] = [];
  
  constructor(data?: Partial<AddLecturaInmueble>) {
    Object.assign(this, data);
  }
}